import faDragon from "icons/solid/dragon.svg";
import faRaygun from "icons/solid/raygun.svg";
import faFaceLaugh from "icons/solid/face-laugh.svg";
import faRoute from "icons/solid/route.svg";
import faLandmark from "icons/solid/landmark.svg";
import faHammerWar from "icons/solid/hammer-war.svg";
import faVenusMars from "icons/solid/venus-mars.svg";
import faHeart from "icons/solid/heart.svg";
import faCommentDots from "icons/solid/comment-dots.svg";
import faFaceSmile from "icons/solid/face-smile.svg";
import faFaceSadCry from "icons/solid/face-sad-cry.svg";
import faHouseFire from "icons/solid/house-fire.svg";
import faUserAstronaut from "icons/solid/user-astronaut.svg";
import faAlien from "icons/solid/alien.svg";
import faMagnifyingGlass from "icons/solid/magnifying-glass.svg";
import faVenus from "icons/solid/venus.svg";
import faFamily from "icons/solid/family.svg";
import faBookUser from "icons/solid/book-user.svg";
import faBookSparkles from "icons/solid/book-sparkles.svg";
import faBookAtlas from "icons/solid/book-atlas.svg";
import faUserGraduate from "icons/solid/user-graduate.svg";
import faPepperHot from "icons/solid/pepper-hot.svg";

export const tagIconMap = {
  genre: {
    fantasy: faDragon,
    "science fiction": faRaygun,
    "young adult": faUserGraduate,
    adventure: faRoute,
    classics: faLandmark,
    war: faHammerWar,
    lgbtq: faVenusMars,
    romance: faHeart,
    comics: faCommentDots,
    dystopian: faHouseFire,
    space: faUserAstronaut,
    aliens: faAlien,
    mystery: faMagnifyingGlass,
    women: faVenus,
    family: faFamily,
    biography: faBookUser,
    fiction: faBookSparkles,
    nonfiction: faBookAtlas,
    adult: faPepperHot,
  },
  mood: {
    funny: faFaceLaugh,
    happy: faFaceSmile,
    sad: faFaceSadCry,
    adventurous: faRoute,
  },
};
